<template>
  <div>
    <div class="shopcart">
      <div class="content">
        <div class="content-left">
          <div class="logo-wrapper">
            <!-- <div class="logo" :class="{'highlight':totalCount>0}">
              <i class="icon-shopping_cart iconfont" :class="{'highlight':totalCount>0}">&#xe6ad;</i>
            </div> -->
            <div>
              <img v-if="totalCount > 0" src="@/assets/image/tab/shopping_cart.svg" />
              <img v-else src="@/assets/image/tab/shopping_cart_gray.svg" />
            </div>
            <div class="num" v-show="totalCount>0">
              <bubble :num="totalCount" class="cartBubble"></bubble>
            </div>
          </div>
          <div class="price" :class="{'highlight':totalPrice>0}">＄{{totalPrice}}</div>
        </div>
        <div class="content-right" @click="showConfirmDetail">
          <div class="pay" :class="payClass">
            <img src="@/assets/image/tab/logo.svg" style="width: 2.3rem" />{{payDesc}}
          </div>
        </div>
        <!-- <div class="content-right" @click="pay">
          <div class="pay" :class="payClass">
            {{payDesc}}
          </div>
        </div> -->
      </div>
      <div class="ball-container">
        <div v-for="(ball,index) in balls" :key="index">
          <transition
            @before-enter="beforeDrop"
            @enter="dropping"
            @after-enter="afterDrop">

          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bubble from './bubble'
import { mapActions } from 'vuex'

const BALL_LEN = 10
const innerClsHook = 'inner-hook'

function createBalls () {
  let balls = []
  for (let i = 0; i < BALL_LEN; i++) {
    balls.push({ show: false })
  }
  return balls
}

export default {
  name: 'shop-cart',
  props: {
    selectFoods: {
      type: Array,
      default () {
        return []
      }
    },
    store_id: {
      // type: Number
    },
    minPrice: {
      type: Number,
      default: 0
    },
    sticky: {
      type: Boolean,
      default: false
    },
    fold: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      balls: createBalls(),
      listFold: this.fold
    }
  },
  created () {
    this.dropBalls = []
  },
  computed: {
    totalPrice () {
      let total = 0
      let selectedFood=[]
      this.selectFoods.forEach((food) => {
        if(typeof (selectedFood[food.goods_id])=='undefined'){
          if(food.spec_list){
            for(var i in food.spec_list){
              if(food.spec_list[i].count){
                total += food.spec_list[i].goods_price * food.spec_list[i].count
              }
            }
          }else{
            total += food.goods_price * food.count
          }
          selectedFood[food.goods_id]=1

        }
      })
      return this.utils.currencyPrice(total)
    },
    totalCount () {
      let count = 0
      let selectedFood=[]
      this.selectFoods.forEach((food) => {
        if(typeof (selectedFood[food.goods_id])=='undefined'){
          selectedFood[food.goods_id]=1
          count += food.count
        }
      })
      return count
    },
    payDesc () {
      if (this.totalPrice === 0) {
        return `$${this.$t('shop_cart.minimum_order', [this.utils.currencyPrice(this.minPrice)])}`
      } else if (this.totalPrice < this.minPrice) {
        let diff = this.minPrice - this.totalPrice
        return this.$t('shop_cart.short_by', [this.utils.currencyPrice(diff)])
      } else {
        return this.$t('shop_cart.checkout')
      }
    },
    payClass () {
      if (!this.totalCount || this.totalPrice < this.minPrice) {
        return 'not-enough'
      } else {
        return 'enough'
      }
    }
  },
  methods: {
    ...mapActions({
		  setDetail: 'setDetail'
	  }),
    pay (e) {
      if (this.totalPrice === 0) {
        return
      }
      if (this.totalPrice < this.minPrice) {
        return
      }
      let cartIdTemp = []
      this.selectFoods.forEach((food) => {
        if(food.spec_list){
            for(var i in food.spec_list){
              if(food.spec_list[i].count){
                cartIdTemp.push(food.spec_list[i].cart_id + '|' + food.spec_list[i].store_id)
              }
            }

        }else{
          cartIdTemp.push(food.cart_id + '|' + food.store_id)
        }
      })
      let cartId = cartIdTemp.join(',')
      this.$router.push({ 'name': 'MemberBuyStep1', 'query': { 'cart_id': cartId } })
    },
    drop (el) {
      for (let i = 0; i < this.balls.length; i++) {
        const ball = this.balls[i]
        if (!ball.show) {
          ball.show = true
          ball.el = el
          this.dropBalls.push(ball)
          return
        }
      }
    },
    beforeDrop (el) {
      const ball = this.dropBalls[this.dropBalls.length - 1]
      const rect = ball.el.getBoundingClientRect()
      const x = rect.left - 32
      const y = -(window.innerHeight - rect.top - 22)
      el.style.display = ''
      el.style.transform = el.style.webkitTransform = `translate3d(0,${y}px,0)`
      const inner = el.getElementsByClassName(innerClsHook)[0]
      inner.style.transform = inner.style.webkitTransform = `translate3d(${x}px,0,0)`
    },
    dropping (el, done) {
      this._reflow = document.body.offsetHeight
      el.style.transform = el.style.webkitTransform = `translate3d(0,0,0)`
      const inner = el.getElementsByClassName(innerClsHook)[0]
      inner.style.transform = inner.style.webkitTransform = `translate3d(0,0,0)`
      el.addEventListener('transitionend', done)
    },
    afterDrop (el) {
      const ball = this.dropBalls.shift()
      if (ball) {
        ball.show = false
        el.style.display = 'none'
      }
    },
    showConfirmDetail () {
      if (this.totalCount > 0) {
        this.$router.push({ name: 'MemberBuyStep00' })
      }
    }
  },
  watch: {
    fold (newVal) {
      this.listFold = newVal
    }
  },
  components: {
    Bubble
  }
}
</script>

<style lang="stylus" scoped>
  .cartBubble
    background: white;
    color: #B22433;
  .shopcart
    height: 100%
    .content
      display: flex
      background: #f4c41e
      font-size: 0
      color: #999
      .content-left
        flex: 1
        .logo-wrapper
          display: inline-block
          vertical-align: top
          position: relative
          top: -0.9rem
          padding: 0.3rem
          width: 7.8rem
          box-sizing: border-box
          .logo
            width: 100%
            height: 100%
            border-radius: 50%
            text-align: center
            background:#333
            &.highlight
              background: #00a0dc
            .icon-shopping_cart
              line-height: 2.2rem
              font-size: 1.2rem
              color: #999
              &.highlight
                color: #fff
          .num
            position: absolute;
            left: 1.8rem;
            top: 1.1rem;
        .price
          position: absolute;
          left: 5.2rem;
          color: #E88A17;
          display: inline-block
          vertical-align: top
          margin-top: 0.6rem
          line-height: 1.2rem
          padding-right: 0.6rem
          box-sizing: border-box
          font-weight: 700
          font-size: 0.7rem
          &.highlight
            color: #e88a17
        .desc
          display: inline-block
          vertical-align: top
          margin: 0.6rem 0 0 0.6rem
          line-height: 1.2rem
          font-size: 0.5rem
      .content-right
        flex: 0 0 8.25rem
        width: 8.25rem
        .pay
          height: 2.4rem
          line-height: 2.4rem
          text-align: center
          font-weight: 500
          font-size:0.8rem
          background: #DD2C35;
          border-radius: 30px;
          color: white;
          letter-spacing: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
        .pay.not-enough
          background: #7F7F80;
    .ball-container
      .ball
        position: fixed
        left: 1.6rem
        bottom: 1.1rem
        z-index: 200
        transition: all 0.4s cubic-bezier(0.49, -0.29, 0.75, 0.41)
        .inner
          width: 0.8rem
          height: 0.8rem
          border-radius: 50%
          background:#00a0dc
          transition: all 0.4s linear
</style>
